import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import TestimonialsSection from './../block/TestimonialsSection'
import WhyTrustUsSection from './../block/WhyTrustUsSection'
import FAQSection from './../block/FAQSection'

export default class Feedback extends Component {

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <WhyTrustUsSection
          page_data={data?.page_data || {}}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Feedback.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}